export function Brand({ compact = false, onColor = false }: { compact?: boolean; onColor?: boolean }) {
  return (
    <a className={onColor ? "brand brand-on-color" : "brand"} href="/" aria-label="Floptropica One home">
      <img className={compact ? "brand-logo compact" : "brand-logo"} src="/assets/floptropica-one-logo.png" alt="Floptropica One" />
    </a>
  );
}
